import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-opacity": ".7",
      d: "M18.462 3A2.54 2.54 0 0 1 21 5.538v12.923A2.54 2.54 0 0 1 18.462 21H5.538A2.54 2.54 0 0 1 3 18.462V5.538A2.54 2.54 0 0 1 5.538 3h12.923zM5.538 4.384c-.637 0-1.154.517-1.154 1.154v12.923c0 .637.517 1.154 1.154 1.154h12.923c.637 0 1.154-.517 1.154-1.154V5.538c0-.637-.517-1.154-1.154-1.154z"
    }, null, -1)
  ]))]))
}
export default { render: render }